exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-55f7daaf] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.divider-line[data-v-55f7daaf] {\n  margin-top: 16px;\n}\n.features-wrapper[data-v-55f7daaf] {\n  height: calc(100vh - 205px);\n}\n.feature-upload[data-v-55f7daaf], .feature-chat[data-v-55f7daaf]\n{\n  display: none;\n}\n", ""]);

// exports
